import {
    Dialog,
    InputNumber,
    Loading,
    Message,
    MessageBox,
} from 'element-ui';
import Vue from 'vue';
import VueI18n from 'vue-i18n';
import App from './App';
import store from './vuex/store';
import prepareState from './vuex/prepareState';

Vue.config.productionTip = false;

Vue.config.keyCodes = {
    l: 76,
};

Vue.use(VueI18n);
Vue.use(Dialog);
Vue.use(InputNumber);
Vue.use(Loading);

Vue.prototype.$message = Message;
Vue.prototype.$confirm = MessageBox.confirm;
Vue.prototype.$alert = MessageBox.alert;

// eslint-disable-next-line no-underscore-dangle
const el = window.__APP_CONFIG__ && window.__APP_CONFIG__.el ? window.__APP_CONFIG__.el : '#app';

const html = document.getElementsByTagName('html')[0];
const lang = (html.lang && (html.lang !== '')) ? html.lang : 'en';

const i18n = new VueI18n({
    locale: lang,
    missing: (locale, key) => `[ERR!] ${key}`,
});

// eslint-disable-next-line no-underscore-dangle
window.__SEAT_BOOKING_APP__ = new Vue({
    el,
    i18n,
    template: '<App/>',
    components: { App },
    store,
    mounted() {
        // eslint-disable-next-line no-underscore-dangle
        if (window.__INITIAL_STATE__) {
            // eslint-disable-next-line no-underscore-dangle
            this.$store.replaceState(prepareState(window.__INITIAL_STATE__));
        }
    },
});



// WEBPACK FOOTER //
// ./src/main.js